import { useEffect, useState, useCallback } from 'react';
import { useAppContext } from "use-app";
import repo from 'service/repository';

const STATES = {
  idled: {
    fetch: 'fetching',
  },
  fetching: {
    success: 'success',
    error: 'error',
  },
  success: {
    fetch: 'fetching',
  },
  error: {
    refetch: 'fetching',
    reload: 'fetching',
  },
};

const move = current => {
  const actions = STATES?.[current];
  return action => {
    const next = actions?.[action]

    return next ?? current;
  };
};

export const useCoupons = ({ state } = { state: ['available'] }) => {
  const [coupons, setCoupons] = useState([]);
  const [status, setStatus] = useState('idled');
  const [paging, setPaging] = useState(null);
  const appContext = useAppContext()

  const isEnd = paging ? paging?.totalPage <= paging?.currentPage : false;

  useEffect(() => {
    const init = async () => {
      if (status !== 'idled') return; 

      setStatus(prev => {
        return move(prev)('fetch');
      });
      try {
        const res = await repo.fetchCoupons({ state, page: 1 });

        setStatus(prev => {
          return move(prev)('success');
        });
        setPaging(res.data.paging);
        setCoupons(res.data.data);
      } catch (err) {
        setStatus(prev => {
          return move(prev)('error');
        });
        setCoupons([]);
      }
    };

    if (status !== 'idled') return; 

    init();
  }, [state.join('')]);


  const next = useCallback(async () => {
    if (status !== 'success' || isEnd || !paging) {
      return;
    }

    setStatus(prev => {
      return move(prev)('reload');
    });
    try {
      const res = await repo.fetchCoupons({ state, page: paging.currentPage + 1 });

      setStatus(prev => {
        return move(prev)('success');
      });
      setPaging(res.data.paging);

      setCoupons(prev => {
        return [...prev, ...res.data.data];
      });
    } catch (err) {
      setStatus(prev => {
        return move(prev)('error');
      });
    }
  }, [isEnd, paging, state, status]);

  const reload = useCallback(async () => {
    if (status !== 'error') {
      return;
    }

    try {
      const res = await repo.fetchCoupons({ state, page: 1 });

      setStatus(prev => {
        return move(prev)('success');
      });
      setPaging(res.data.paging);
      setCoupons(res.data.data);
    } catch (err) {
      appContext.showFailMessage('oops... 有東西出錯了');
      setStatus(prev => {
        return move(prev)('error');
      });
      setCoupons([]);
    }
  }, [appContext, state, status])

  return {
    coupons,
    status,
    next,
    isEnd,
    reload
  };
};
